

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"build-1793127390616"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";

const EXTENSION_FILENAME_PREFIXES = [
  'app:///',
  'chrome-extension://',
  'moz-extension://',
  'safari-web-extension://',
];

const shouldIgnoreThirdPartyGoogleLoaderNoise = (event: Sentry.ErrorEvent) => {
  const exceptionValues = event.exception?.values || [];

  // Ignore any error whose entire stack trace originates from Google's GSI client
  // running inside a browser extension context (app:/// scheme). These are not
  // errors in our code — e.g. "NotFoundError: The object can not be found here."
  const allFramesFromGsiExtension = exceptionValues.every((value) => {
    const frames = value?.stacktrace?.frames;
    if (!frames || frames.length === 0) return false;
    return frames.every((frame) => {
      const filename = frame?.filename || '';
      return EXTENSION_FILENAME_PREFIXES.some((prefix) => filename.startsWith(prefix));
    });
  });
  if (allFramesFromGsiExtension && exceptionValues.length > 0) {
    return true;
  }

  const message = exceptionValues
    .map((value) => value?.value || '')
    .join(' ')
    .toLowerCase();

  if (!message.includes('jsloader error') || !message.includes('apis.google.com/js/client.js')) {
    return false;
  }

  return exceptionValues.some((value) =>
    value?.stacktrace?.frames?.some((frame) => {
      const filename = frame?.filename || '';
      return EXTENSION_FILENAME_PREFIXES.some((prefix) => filename.startsWith(prefix));
    })
  );
};

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  integrations: [
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event) {
    if (shouldIgnoreThirdPartyGoogleLoaderNoise(event as Sentry.ErrorEvent)) {
      return null;
    }
    return event;
  },
  debug: false,
});
